import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const SupportSelectionPage = ({ data, onUpdate }) => {
  const [supportType, setSupportType] = useState(data.supportType || "");
  const [fieldErrors, setFieldErrors] = useState({
    supportType: ''
  });

  // Update parent component when data changes
  useEffect(() => {
    onUpdate({
      supportType
    });
  }, [supportType]);

  // Handle support type selection
  const handleSupportTypeChange = (type) => {
    setSupportType(type);
    setFieldErrors(prev => ({
      ...prev,
      supportType: ''
    }));
    scrollTo('support-form');
  };

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // Scroll to the element with some offset from the top
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  };

  return (
    <div className="wizard-page support-selection-page">
      <div className="page-header">
        <h2>What level of support would you prefer?</h2>
        <p>Choose the support option that best fits your needs. You can always upgrade or downgrade later.</p>
      </div>

      <div className="form-content" id="support-form">
        <div className="form-group">
          <div className="support-options">
            <div className="support-option">
              <input
                type="radio"
                id="self-service"
                name="supportType"
                value="self-service"
                checked={supportType === 'self-service'}
                onChange={() => handleSupportTypeChange('self-service')}
                className="support-radio"
              />
              <label htmlFor="self-service" className="support-label">
                <div className="support-content">
                  <div className="support-title">Self-service support</div>
                  <div className="support-description">
                    Access to comprehensive help documentation.
                    Perfect if you have technical expertise in your team.
                  </div>
                </div>
              </label>
            </div>

            <div className="support-option">
              <input
                type="radio"
                id="premium-support"
                name="supportType"
                value="premium-support"
                checked={supportType === 'premium-support'}
                onChange={() => handleSupportTypeChange('premium-support')}
                className="support-radio"
              />
              <label htmlFor="premium-support" className="support-label">
                <div className="support-content">
                  <div className="support-title">Premium support</div>
                  <div className="support-description">
                    Direct access to our technical support team via email and phone.
                    Priority response times and dedicated support for complex issues.
                  </div>
                </div>
              </label>
            </div>
          </div>

          {fieldErrors.supportType && (
            <span className="field-error">{fieldErrors.supportType}</span>
          )}
        </div>
      </div>
    </div>
  );
};

SupportSelectionPage.propTypes = {
  data: PropTypes.shape({
    supportType: PropTypes.string
  }).isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default SupportSelectionPage;
